import { useQuery } from "urql"

import { GetAssociatedProductIdsByCompanyDocument } from "@/graphql/codegen/graphql"

interface UseGetAssociatedProductIdsReturn {
  associatedProductIds: number[]
  isFetching: boolean
}

export const useGetAssociatedProductIds = (companyId: string): UseGetAssociatedProductIdsReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetAssociatedProductIdsByCompanyDocument,
    variables: { companyId },
  })

  const associatedProductIds = data?.companyProductAssociation?.getAssociatedProductIdsByCompany ?? []

  return { associatedProductIds, isFetching: fetching }
}
